const uuidv1 = require('uuid/v1')

function buildHtmlSection(parts, createId) {
  const nextId = createId || uuidv1
  const id = nextId()
  const input = parts || {}
  return {
    element: 'SectionHtml',
    name: 'html-section:' + id,
    id: 'html-section:' + id,
    props: {
      'heading-text': '',
      'sub-text': '',
      html: typeof input.html === 'string' ? input.html : '',
      css: typeof input.css === 'string' ? input.css : '',
      js: typeof input.js === 'string' ? input.js : '',
    },
  }
}

module.exports = {buildHtmlSection}
